import styles from './LegalPage.module.css';

const ReturnsPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1>Returns & Refund Policy</h1>
        <p className={styles.lastUpdated}>Last Updated: November 3, 2025</p>

        <section>
          <p>
            At Oval Care, Inc., we are committed to providing the highest level of patient care and affordable access to healthcare products and services. If you experience an issue with your order or product, please contact our Patient Care Team at +1 (737) 396‑1791 or email <a href="mailto:support@ovalcare.com">support@ovalcare.com</a>. We will make every effort to resolve your concern promptly. Below you will find details on our return and refund process based on product type.
          </p>
        </section>

        <section>
          <h2>1. Prescription Medications</h2>
          <p>
            Federal and state regulations prohibit the return of prescription medications once they have been dispensed by the pharmacy. Once your payment has been processed and your order has been shipped (via USPS, FedEx, or UPS), all sales are final.
          </p>
          <p>
            You may update or cancel your order before it ships by logging into your OvalCare.com account.
          </p>
          <p>
            If your prescription medication arrives damaged, incorrect, or is lost during transit, please contact our Patient Care Team immediately at +1 (737) 396‑1791 or <a href="mailto:support@ovalcare.com">support@ovalcare.com</a>. Our team will assist in resolving the issue, which may include reshipment at no additional cost when appropriate.
          </p>
        </section>

        <section>
          <h2>2. Over-the-Counter (Non-Prescription) Products</h2>
          <p>
            Oval Care accepts returns on unopened, unused, and non-prescription products within 30 days of purchase. To initiate a return:
          </p>
          <ul>
            <li>Contact <a href="mailto:support@ovalcare.com">support@ovalcare.com</a> or call +1 (737) 396‑1791.</li>
            <li>Provide your order number, product name, and reason for return.</li>
          </ul>

          <p><strong>Please note:</strong></p>
          <ul>
            <li>Customers are responsible for return shipping costs.</li>
            <li>We do not accept COD (Cash on Delivery) returns.</li>
            <li>Products must be returned in their original condition and packaging. Items that appear used, opened, or tampered with will not be eligible for a refund.</li>
          </ul>

          <p>
            Once your return is received and approved, a refund will be issued to your original method of payment within 7–10 business days.
          </p>

          <h3>Return Address</h3>
          <address>
            Oval Care, Inc.<br />
            Attn: Returns Department<br />
            848 Brickell Avenue PH5,<br />
            Miami, FL 33131<br />
            United States
          </address>
        </section>

        <section>
          <h2>3. Lost or Delayed Packages</h2>
          <p>
            If your package is lost in transit, Oval Care will work directly with the carrier to locate or replace your order. Please contact our Patient Care Team if your order:
          </p>
          <ul>
            <li>Has not arrived within the estimated delivery window, or</li>
            <li>Appears to be lost or misdelivered.</li>
          </ul>
          <p>
            We will investigate with USPS, FedEx, or UPS and, if confirmed lost, reship your order at no additional cost. Please note that weather or carrier delays may occasionally extend delivery times. Since Oval Care does not currently ship refrigerated products, increased transit time will not affect product quality.
          </p>
        </section>

        <section>
          <h2>4. Contact Us</h2>
          <p>
            If you have questions or need assistance with a return or refund, contact us at:
          </p>
          <address>
            Oval Care, Inc.<br />
            Attn: Patient Care Team<br />
            848 Brickell Avenue PH5,<br />
            Miami, FL 33131<br />
            United States<br />
            Phone: +1 (737) 396‑1791<br />
            Email: <a href="mailto:support@ovalcare.com">support@ovalcare.com</a>
          </address>
        </section>
      </div>
    </div>
  );
};

export default ReturnsPage;
